<template>
	<div class="loader"  v-show-hide-delay="shown"></div>
</template>

<script>
export default {

  name: 'i-loader',
  props:["shown"],
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
.loader {
    border: 7px solid #f3f3f3; /* Light grey */
    border-top: 7px solid black; /* Blue */
    border-radius: 50%;
    width: 64px;
    height: 64px;
    animation: spin 1s linear infinite;
    position: absolute;
    margin-left:-32px;
    margin-top:-32px;
    top:50%;
    left:50%;
    z-index: 14;
}
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
.loader{
	opacity: 0;
	transition: 0.3s all ease;
}
.loader.shown{
	opacity: 1;
}

</style>